import useMutation from 'api/hooks/useMutation';
import useTrackWithUser from 'api/hooks/useTrackWithUser';
import permissions from 'api/Apollo/permissions';

import { SAMPLE_EVENTS_QUERY } from 'api/sample-events/sample-events-query-builder';
import { ALL_SAMPLE_EVENT_NAMES_QUERY } from 'api/sample-events/useQuerySampleEventNames';

import {
  mutation as insertSampleEventMutation,
  buildVariables as buildInsertSampleEventVariables,
} from './insert-sample-event-mutation-builder';

export default function useInsertSampleEvent(options = {}) {
  const [trackWithUser] = useTrackWithUser('sample_event_created');
  const [executeMutation, response] = useMutation(insertSampleEventMutation, {
    successMsg: 'Sample event created',
    refetchQueries: [SAMPLE_EVENTS_QUERY, ALL_SAMPLE_EVENT_NAMES_QUERY],
    ...options,
    context: { permission: permissions.writeSampleEvents },
  });

  const insertSampleEvent = async ({ name, description = '', eventJson }) => {
    const mutationResponse = await executeMutation({
      variables: buildInsertSampleEventVariables({ name, description, eventJson }),
    });

    if (!mutationResponse.errors) {
      trackWithUser();
    }

    return mutationResponse;
  };

  return [insertSampleEvent, response];
}
